import { memo } from 'react';
import { cn } from '@/lib/utils';
import { ILeadFilterTabsProps, TLeadTemperature } from '@/@types/leads';

interface IFilterTabConfig {
  id: TLeadTemperature | 'all';
  label: string;
  className: string;
}

const filterTabs: IFilterTabConfig[] = [
  {
    id: 'all',
    label: 'All',
    className:
      'bg-muted text-foreground border-border light:bg-[#f1f5f9] light:text-[#111827] light:border-[#94a3b8]',
  },
  {
    id: 'hot',
    label: 'Hot',
    className:
      'bg-[#EC4899]/20 text-[#EC4899] border-[#EC4899] light:bg-[#fce7f3] light:text-[#db2777] light:border-[#db2777]',
  },
  {
    id: 'warm',
    label: 'Warm',
    className:
      'bg-[#F59E0B]/20 text-[#F59E0B] border-[#F59E0B] light:bg-[#fef3c7] light:text-[#d97706] light:border-[#d97706]',
  },
  {
    id: 'cold',
    label: 'Cold',
    className:
      'bg-[#06B6D4]/20 text-[#06B6D4] border-[#06B6D4] light:bg-[#cffafe] light:text-[#0891b2] light:border-[#0891b2]',
  },
];

export const LeadFilterTabs = memo(function LeadFilterTabs({
  counts,
  onFilterChange,
}: ILeadFilterTabsProps) {
  return (
    <div className="flex items-center gap-2 h-[52px] px-6 border-b border-border">
      {filterTabs.map(tab => {
        const count = tab.id === 'all' ? counts.all : counts[tab.id];

        return (
          <button
            key={tab.id}
            onClick={() => onFilterChange(tab.id)}
            className={cn(
              'inline-flex items-center gap-2 px-4 py-2 rounded-full text-[13px] font-medium border transition-all',
              tab.className
            )}
          >
            <span>{tab.label}</span>
            <span className="opacity-70">{count}</span>
          </button>
        );
      })}
    </div>
  );
});
